// The Activity tab's pills. Each `select(items, me)` narrows the feed rows already loaded, so a
// pill's count and its list can't disagree. `me` is the signed-in user's guid.
const sameId = (a, b) => !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();

// A PaymentRequestPaid row has the customer as actor, so it's attributed to whoever accepted the
// suggestion that produced the request — the same rule the BFF uses to name the actor.
const actedBy = (item, me) =>
  sameId(item.activity?.actorId ?? item.activity?.suggestionAcceptedByUserId, me);

export const ACTIVITY_FILTERS = [
  { key: "all", label: "All", select: (items) => items },
  { key: "payments", label: "Payments", select: (items) => items.filter((i) => i.type === "payment") },
  {
    key: "reminders",
    label: "Reminders",
    select: (items) => items.filter((i) => i.activity?.eventName === "PaymentRequestReminderSent"),
  },
  { key: "mine", label: "Mine", select: (items, me) => items.filter((i) => actedBy(i, me)) },
];
